var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 52",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m52 26c0 11.6-7.7 21.5-18.2 24.8v-8.6c0-2.3-1-4.4-2.6-5.8 6.1-1.2 10.4-4.7 10.4-10.4 0-2.9-1.1-5.5-3-7.7 0.1-0.5 0.4-1.7 0.4-3.7 0-1.2-0.1-2.7-0.7-4.2 0 0-3.7 0-7.2 3.3-1.6-0.4-3.3-0.7-5.1-0.7-1.8 0-3.5 0.3-5.1 0.7-3.5-3.3-7.3-3.3-7.3-3.3-0.5 1.5-0.6 3-0.6 4.2 0 1.9 0.3 3 0.5 3.6-1.9 2.2-3.1 4.9-3.1 7.8 0 5.7 4.3 9.2 10.4 10.4-1.4 1.2-2.2 2.9-2.5 4.8-0.6 0.3-1.4 0.4-2.4 0.4-0.8 0-2.3-0.4-3.7-2.6-0.6-0.9-1.8-2.6-3.4-2.6-0.3 0-1 0-1 0.5 0 0.2 0.4 0.2 1.1 0.9 0.7 0.6 1.3 1.5 1.5 2.5 0.4 1.6 1.9 4.9 5.5 4.9 1.3 0 2.3-0.3 2.3-0.3v5.9c-10.5-3.3-18.2-13.2-18.2-24.8 0-14.4 11.6-26 26-26 14.4 0 26 11.6 26 26zm-32 25.3q-0.9-0.2-1.8-0.5 0.9 0.3 1.8 0.5zm13.8-0.5q-0.9 0.3-1.8 0.5 0.9-0.2 1.8-0.5zm-6 1.1q-0.9 0.1-1.8 0.1 0.9 0 1.8-0.1zm4-0.6q-1.8 0.4-3.6 0.6 1.8-0.2 3.6-0.6zm-5.8 0.7q-0.9 0-1.8-0.1 0.9 0.1 1.8 0.1zm-2.2-0.1q-1.8-0.2-3.6-0.6 1.8 0.4 3.6 0.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.092f05d4f6194a87bb96b4aee87ba432.svg";
export { ForwardRef as ReactComponent };